import { RSAA } from 'redux-api-middleware';

const FETCH_NLP_TRANSCRIPT_REQUEST = 'FETCH_NLP_TRANSCRIPT_REQUEST';
const FETCH_NLP_TRANSCRIPT_SUCCESS = 'FETCH_NLP_TRANSCRIPT_SUCCESS';
const FETCH_NLP_TRANSCRIPT_FAILURE = 'FETCH_NLP_TRANSCRIPT_FAILURE';

export const fetchNlpTranscript = (eventId: string) => ({
  [RSAA]: {
    types: [FETCH_NLP_TRANSCRIPT_REQUEST, FETCH_NLP_TRANSCRIPT_SUCCESS, FETCH_NLP_TRANSCRIPT_FAILURE],
    endpoint: `/nlp/transcript/${eventId}`,
    method: 'GET',
  },
});
